/**
 * Created by chenzheyu on 2017/6/21.
 */
import XkAlertBox from './src/alertBox.vue'

XkAlertBox.install = function (Vue) {
  Vue.component(XkAlertBox.name, XkAlertBox)
}

export default XkAlertBox



// WEBPACK FOOTER //
// ./src/components/module/alertBox/index.js